// export const exampleExperimentOptimizelyConfig = {
//   // Staging
//   554664308: {
//     pageName: 'get_page_optimizely_stage_dashboard',
//     experimentId: 'get_page_optimizely_stage_dashboard',
//     variationId: 'get_page_optimizely_stage_dashboard'
//   },
//   // Production
//   566520915: {
//     pageName: 'get_page_optimizely_prod_dashboard',
//     experimentId: 'get_page_optimizely_prod_dashboard',
//     variationId: 'get_page_optimizely_prod_dashboard'
//   }
// };

export const fastFacetsDesktopOptimizelyTest = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_fast_facets_test_desktop',
    experimentId: '14896670642',
    variationId: '14921090486'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_fast_facets_test_desktop',
    experimentId: '14923090463',
    variationId: '14882620624'
  }
};

export const fastFacetsMobileOptimizelyTest = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_fast_facets_test_mobile_web',
    experimentId: '14894800524',
    variationId: '14911210472'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_fast_facets_test_mobile_web',
    experimentId: '14913070735',
    variationId: '14919080585'
  }
};

export const invitesPriceColorConfig = {
  // Staging
  554664308: { // Project ID
    pageName: '554664308_url_targeting_for_invites_price_color', // API Name
    experimentId: '17611160066', // Experiment ID
    variationId: '17591750352' // Test Variation ID
  },
  // Production
  566520915: { // Project ID
    pageName: '566520915_url_targeting_for_invites_price_color', // API Name
    experimentId: '17597900571', // Experiment ID
    variationId: '17616970634' // Test Variation ID
  }
};

export const invitesWeddingShopModalConfig = {
  // Staging
  554664308: { // Project ID
    pageName: '554664308_url_targeting_for_invites__wedding_shop_modal', // API Name
    experimentId: '17793010369', // Experiment ID
    variationId: '17789380229' // Test Variation ID
  },
  // Production
  566520915: { // Project ID
    pageName: '566520915_url_targeting_for_invites__wedding_shop_modal', // API Name
    experimentId: '17783940363', // Experiment ID
    variationId: '17786000030' // Test Variation ID
  }
};

export const invitesPlpRedesignConfig = {
  // Staging
  554664308: { // Project ID
    pageName: '554664308_url_targeting_for_invites__plp_redesign', // API Name
    experimentId: '18128220165', // Experiment ID
    variationId: '18129910370' // Test Variation ID
  },
  // Production
  566520915: { // Project ID
    pageName: '566520915_url_targeting_for_invites__plp_redesign', // API Name
    experimentId: '18128110147', // Experiment ID
    variationId: '18140140101' // Test Variation ID
  }
};
const optimizelyConfigs = {
  fastFacetsDesktopOptimizelyTest,
  fastFacetsMobileOptimizelyTest,
  invitesPriceColorConfig,
  invitesWeddingShopModalConfig,
  invitesPlpRedesignConfig
};

export default optimizelyConfigs;



// WEBPACK FOOTER //
// ./src/util/optimizelyConfigs.js